import axios from "axios";
import React, { Fragment, useCallback, useEffect, useState } from "react";
import { Button, Container, Form, FormGroup, Dropdown } from "react-bootstrap";
import {
  FaUser,
  FaUserSecret,
  FaUserLock,
  FaMoneyCheck,
  FaHistory,
  FaSearchLocation,
  FaAngleDoubleLeft,
  FaAngleDoubleRight,
  FaAngleDoubleUp,
  FaAngleDoubleDown,
} from "react-icons/fa";
import {
  ADVERTISEMENT_PAGE,
  NORMAL_ADMIN_ACCESS,
  STORE_ADMIN_ACCESS,
  SPONSER_ADMIN_ACCESS,
  STORE_USER_ACCESS,
  SPONSER_USER_ACCESS,
  ADMIN_USER_ACCESS,
  NORMAL_USER_ACCESS,
} from "../../constant/FrontEnd";
import { countryDataArray } from "../../constant/dummyData";
import DatePicker from "react-datepicker";
import { Tab, Nav, Col, Row } from "react-bootstrap";
import "react-datepicker/dist/react-datepicker.css";
import "../../../src/assets/css/scss/component/_userProfile.scss";
// import MuiDataTable from '../../components/table/muiDataTable';
import { useDispatch, useSelector } from "react-redux";
import {
  checkUserAccessAndToken,
  displayIntroVideo,
  getActiveLcdData,
  getHeaderForAxios,
  getOnlyActiveLcdData,
  getSelectedDealBySponsor,
  getSelectedOptions,
  getSelectedSponsorByStore,
  getToken,
  getUserData,
} from "../../common/getLocalStorageData";
import {
  activeDealAdvertisement,
  activeLcd,
  addLcd,
  loaderDisplayHideAction,
} from "../../actions";
import EncryptData from "../../common/encryption";
import { UpdateProfile } from "./updateProfile";
import { Redirect } from "react-router-dom";
import { ChangePassword } from "./changePassword";
import { LcdList } from "./lcdList";
import { DealList } from "./dealList";
import { WinnerHistory } from "./winnerHistory";
import { CertificateList } from "./certificateList";
import { AwardList } from "./awardList";
import { AddressList } from "./addressList";
import { DealListStore } from "./dealListStore";
import { CertificateListStore } from "./certificateListStore";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  TextField,
} from "@material-ui/core";
import { DealLcdList } from "./dealLcdList";
import VideoWrapper from "../videoWrapper";
import { IReduxStateData } from "../../interfaces/redux";
import { SIDE_MENU_PROFILE } from "../../constant/menuAndProfile";
import { isMobileOnly } from "react-device-detect";
// import _ from 'lodash';

export default function Profile() {
  const dispatch = useDispatch();
  const sponserOrAdminAccess = checkUserAccessAndToken(SPONSER_ADMIN_ACCESS);
  // const storeOrAdminAccess = checkUserAccessAndToken(STORE_ADMIN_ACCESS);
  const normalOrAdminAccess = checkUserAccessAndToken(NORMAL_ADMIN_ACCESS);
  const storeAccess = checkUserAccessAndToken(STORE_USER_ACCESS);
  const sponsorAccess = checkUserAccessAndToken(SPONSER_USER_ACCESS);
  const adminAcess = checkUserAccessAndToken(ADMIN_USER_ACCESS);
  const userAcess = checkUserAccessAndToken(NORMAL_USER_ACCESS);
  const userId = getUserData();
  const userData: any = getUserData(false);
  const [advertisementData, setAdvertisementData] = useState([]);
  //sponser
  // const [spDealDropDown, setSPDealDropDown] = useState<any[]>([])
  const [storeData, setStoreData] = useState<any[]>([]);
  const [dealData, setDealData] = useState<any[]>([]);
  const [lcdWinnerList, setLcdWinnerList] = useState<any[]>([]);
  // const [spSelectedDeal, setSPSelectedDeal] = useState<any>({})
  const [storeUsersList, setStoreUsersList] = useState<any[]>([]);
  // const [selectedDropDown, setSelectedDropDown] = useState<any>()
  const globalState = useSelector((state: IReduxStateData) => state);
  const selectedLanguage = globalState?.selectedLang;
  const [selectedBrand, setSelectedBrand] = useState("");
  const [selectedDealName, setSelectedDealName] = useState("");
  const [redirectToNotFoundPage, setRedirectToNotFoundPage] = useState(
    userData ? false : true
  );
  const [dealAllLcdList, setDealAllLcdList] = useState<any[]>([]);

  const [openDialog, setOpenDialog] = useState(false);

  const defaultDealDetail = {
    selectedMaindeal: "",
    selectedItem: "",
    list: [],
  };
  const [dealList, setDealList] = useState<any>(defaultDealDetail);

  const [displayFullSideMenu, setDisplayFullSideMenu] = useState(true);
  const [displayFullRigthMenu, setDisplayFullRightMenu] = useState(true);

  const [displayIntoVideoItem, setDisplayIntoVideoItem] = useState("");
  const defaultSponsorDetail = {
    selectedItem: sponsorAccess ? userId : "",
    list: [],
  };
  const [sponsorList, setSponsorList] = useState<any>(defaultSponsorDetail);
  const [toggleFlag, setToggleFlag] = useState(true);
  const defaultTempSelectedValue = {
    sponsor_uuid: sponsorAccess ? userId : "",
    main_deal_uuid: "",
    deal_uuid: "",
  };
  const [tempSelectedValue, setTempSelectedValue] = useState(
    defaultTempSelectedValue
  );
  const activeDealAdvertisementData = useCallback(
    (advertisementData) => {
      dispatch(activeDealAdvertisement(advertisementData));
    },
    // eslint-disable-next-line
    [dispatch]
  );

  const addLcdData = useCallback(
    (lcdData) => {
      dispatch(addLcd(lcdData));
    },
    // eslint-disable-next-line
    [dispatch]
  );
  const activeLcdDetail = useCallback(
    (lcdData) => {
      dispatch(activeLcd(lcdData));
    },
    // eslint-disable-next-line
    [dispatch]
  );

  // useEffect(() => {
  //   if (dealList && dealList?.selectedMaindeal) {
  //     setTempSelectedValue({ ...tempSelectedValue, "main_deal_uuid": dealList?.selectedMaindeal, "deal_uuid": dealList?.selectedItem })
  //     setToggleFlag(!toggleFlag)
  //   }
  // }, [dealList?.selectedItem])
  // useEffect(() => {
  //   if (sponsorList && sponsorList?.selectedItem && sponsorAccess) {
  //     setTempSelectedValue({ ...tempSelectedValue, "sponsor_uuid": sponsorList?.selectedItem })
  //   }
  // }, [sponsorList, sponsorList?.selectedItem])

  // const onChangeActiveDeal = (mainDealUuid: string = "", dealUuid: string = "", sponsorUuid: string = "") => {
  //   console.log("onChangeActiveDeal >", mainDealUuid, dealUuid)
  //   setDealList({ ...dealList, "selectedMaindeal": mainDealUuid, "selectedItem": dealUuid })
  //   setSponsorList({ ...sponsorList, "selectedItem": sponsorUuid })
  // }
  const onSaveAwardDetail = (data: any) => {
    console.log("onSaveAwardDetail >", data);
  };
  useEffect(() => {
    console.log("user token >", getToken());
    console.log("user id >", userId);
    console.log("user data >", userData);
    setDisplayIntoVideoItem(displayIntroVideo());
    let data = {
      uuid: userId,
      deal_uuid: getOnlyActiveLcdData().data["deal_uuid"],
      page: ADVERTISEMENT_PAGE["myprofile"],
    };
    const headerForApi = getHeaderForAxios();
    axios
      .post(process.env.REACT_APP_API_URL + "/user/userProfile", data, {
        headers: headerForApi,
      })
      .then(function (response) {
        // handle success
        if (response.data && response.data.success) {
          if (
            response.data.success.lcdData &&
            response.data.success.lcdData.length
          ) {
            let lcdData = response.data.success.lcdData;
            localStorage.setItem(
              "lcdData",
              JSON.stringify(EncryptData(lcdData))
            );
            addLcdData(lcdData);
            if (
              !getActiveLcdData().data.length &&
              lcdData[0].alphacode_identifier
            ) {
              localStorage.setItem(
                "alphaIdentifier",
                JSON.stringify(EncryptData(lcdData[0].alphacode_identifier))
              );
              activeLcdDetail({
                activeLcdIdentifier: lcdData[0].alphacode_identifier,
              });
            }
          }
          if (
            response.data.success.advertisement &&
            response.data.success.advertisement.length
          ) {
            setAdvertisementData(response.data.success.advertisement);
          }
        }
      })
      .catch(function (error) {
        // handle error
        console.log(error);
      });
    const getStoreSelcetedOption: any = getSelectedOptions();
    if (getStoreSelcetedOption) {
      let tempSelectedValueDummy = { ...tempSelectedValue };
      if (getStoreSelcetedOption?.deal_uuid) {
        setDealList({
          ...dealList,
          selectedItem: getStoreSelcetedOption?.deal_uuid,
          selectedMaindeal: getStoreSelcetedOption?.main_deal_uuid || "",
        });
        tempSelectedValue["deal_uuid"] =
          getStoreSelcetedOption?.deal_uuid || "";
        tempSelectedValue["main_deal_uuid"] =
          getStoreSelcetedOption?.main_deal_uuid || "";
      }
      if (getStoreSelcetedOption?.sponsor_uuid) {
        setSponsorList({
          ...sponsorList,
          selectedItem: getStoreSelcetedOption?.sponsor_uuid,
        });
        tempSelectedValue["sponsor_uuid"] =
          getStoreSelcetedOption?.sponsor_uuid || "";
      }
      setTempSelectedValue({ ...tempSelectedValueDummy });
    }

    if (sponsorAccess) {
      getSponsorData();
    } else if (storeAccess) {
      getStoreData();
    } else if (normalOrAdminAccess) {
      if (adminAcess) {
        getUserDashboardData(false);
      } else {
        getUserDashboardData(true);
      }
    }

    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const itemFound = sponsorList?.list?.find(
      (item) =>
        sponsorList?.selectedItem.toString() === item.sponsor_uuid.toString()
    );
    if (itemFound?.brand_name) {
      setSelectedBrand(itemFound?.brand_name);
    }
  }, [sponsorList?.list, sponsorList?.selectedItem]);

  const fetchUserDashboardData = async (deal_uuid: string = "") => {
    let data: any = { uuid: userId };
    loaderDisplayHideRedux({ isFullScreenLoaderDisplay: true });
    const headerForApi = getHeaderForAxios();
    if (
      userId &&
      deal_uuid &&
      (deal_uuid !== globalState.previousFetchAdvertisementDeal ||
        !globalState.previousFetchAdvertisementDeal)
    ) {
      data["deal_uuid"] = deal_uuid;
      await axios
        .post(
          process.env.REACT_APP_API_URL + "/deal/get-advertisement",
          {
            user_uuid: userId,
            deal_uuid: deal_uuid,
          },
          { headers: headerForApi }
        )
        .then(function (response) {
          if (response.data && response.data.success) {
            activeDealAdvertisementData(
              response.data.success?.advertisement || []
            );
          }
        })
        .catch(function (error) {
          // handle error
          console.log(error);
        });
    }
    await axios
      .post(process.env.REACT_APP_API_URL + "/user/getDashboardData", data, {
        headers: headerForApi,
      })
      .then(function (response) {
        let winnerList = [];
        if (response.data && response.data.success) {
          console.log("winner list >", response.data.success);
          if (response.data.success?.winners) {
            winnerList = response.data.success?.winners;
          }
        }
        setLcdWinnerList(winnerList);
        loaderDisplayHideRedux({ isFullScreenLoaderDisplay: false });
      })
      .catch(function (error) {
        // handle error
        console.log(error);
        loaderDisplayHideRedux({ isFullScreenLoaderDisplay: false });
      });
  };
  const getUserDashboardData = (fetchDealRelatedDataOnly: boolean = true) => {
    let getSelectedDeal: any = getOnlyActiveLcdData();
    if (fetchDealRelatedDataOnly) {
      fetchUserDashboardData(getSelectedDeal?.data?.deal_uuid || "");
    } else {
      fetchUserDashboardData();
    }
  };
  const fetchSponsorData = async (
    main_deal_uuid: string,
    deal_uuid: string = ""
  ) => {
    let data: any = { user_uuid: userId };
    let selectedMainDealUuid = "";
    let selectedDealUuid = "";
    if (main_deal_uuid) {
      data["main_deal_uuid"] = main_deal_uuid;
    }
    // if (parent_deal_uuid) {
    //   data['parent_deal_uuid'] = parent_deal_uuid;
    // }
    loaderDisplayHideRedux({ isFullScreenLoaderDisplay: true });
    const headerForApi = getHeaderForAxios();
    await axios
      .post(process.env.REACT_APP_API_URL + "/sponsor/getDashboardData", data, {
        headers: headerForApi,
      })
      .then(function (response) {
        if (response.data && response.data.success) {
          let getDropDownData: any[] = [];
          let getStoreData: any[] = [];
          let getDealData: any[] = [];
          let getStoreList: any[] = [];
          if (
            response.data.success?.finalData &&
            response.data.success?.finalData?.dropDown
          ) {
            getDropDownData = response.data.success.finalData.dropDown;
            console.log("dropdown >", getDropDownData);
          }
          if (response.data.success?.store) {
            getStoreData = response.data.success.store;
          }
          if (response.data.success?.storeUsers) {
            getStoreList = response.data.success.storeUsers;
          }
          if (
            response.data.success?.finalData &&
            response.data.success.finalData.dealData &&
            response.data.success?.finalData?.dealData?.length
          ) {
            getDealData = response.data.success.finalData.dealData;
            selectedMainDealUuid =
              response.data.success.finalData.dealData[0].main_deal_uuid;
            const checkDealUuid = response.data.success.finalData.dealData.some(
              (dDetailData: any) => dDetailData?.uuid === deal_uuid
            );
            if (checkDealUuid) {
              selectedDealUuid = deal_uuid;
            }
            if (!selectedDealUuid) {
              selectedDealUuid =
                response.data.success.finalData.dealData[0].uuid;
            }
          }
          setStoreData(getStoreData);
          setDealData(getDealData);
          setStoreUsersList(getStoreList);
          if (selectedMainDealUuid) {
            setDealList({
              ...dealList,
              selectedMaindeal: selectedMainDealUuid,
              selectedItem: selectedDealUuid,
              list: getDropDownData,
            });
            const selectedItemList = {
              main_deal_uuid: selectedMainDealUuid || "",
              deal_uuid: selectedDealUuid || "",
              sponsor_uuid: sponsorAccess ? userId : sponsorList?.selectedItem,
            };
            setTempSelectedValue({ ...selectedItemList });
            localStorage.setItem(
              "selectedOptions",
              JSON.stringify(EncryptData({ ...selectedItemList }))
            );
          }
          setToggleFlag(!toggleFlag);
        }
      })
      .catch(function (error) {
        // handle error
        console.log(error);
      });
    let winnerApiData = {
      user_uuid: userId,
      deal_uuid: selectedDealUuid,
    };
    await axios
      .post(
        process.env.REACT_APP_API_URL + "/sponsor/getWinnerList",
        winnerApiData,
        { headers: headerForApi }
      )
      .then(function (response) {
        let winnerList = [];
        if (
          response.data &&
          response.data.success &&
          response.data.success.length
        ) {
          console.log("winner list >", response.data.success);
          if (response.data.success[0]?.winners) {
            winnerList = response.data.success[0]?.winners;
          }
        }
        setLcdWinnerList(winnerList);
        loaderDisplayHideRedux({ isFullScreenLoaderDisplay: false });
      })
      .catch(function (error) {
        // handle error
        console.log(error);
        loaderDisplayHideRedux({ isFullScreenLoaderDisplay: false });
      });
  };

  const getSponsorData = () => {
    let getSelectedUuid: any = getSelectedOptions();
    fetchSponsorData(
      getSelectedUuid?.main_deal_uuid || "",
      getSelectedUuid?.deal_uuid || ""
    );
  };

  const fetchStoreData = async (sponsor: string, deal: string) => {
    let data: any = { user_uuid: userId };
    let selectedUuid = "";
    if (sponsor) {
      data["sponsor_uuid"] = sponsor;
    }
    if (deal) {
      data["deal_uuid"] = deal;
    }
    loaderDisplayHideRedux({ isFullScreenLoaderDisplay: true });
    await axios
      .post(process.env.REACT_APP_API_URL + "/store/getDashboardData", data, {
        headers: getHeaderForAxios(),
      })
      .then(function (response) {
        if (response.data && response.data.success) {
          let getDropDownData: any[] = [];
          let getSponsorData: any[] = [];
          let winnerData: any[] = [];
          let winnerList: any[] = [];
          let allDealData: any[] = [];
          let dealAllLcdListData: any[] = [];
          let dealListDummy = { ...dealList };
          let sponsorListDummy = { ...sponsorList };
          if (response.data.success.dropDown) {
            getDropDownData = response.data.success.dropDown;
            if (sponsor) {
              sponsorListDummy["selectedItem"] = sponsor;
            }
            sponsorListDummy["list"] = getDropDownData;
          }
          if (response.data.success.sponserData) {
            getSponsorData = response.data.success.sponserData;
            selectedUuid = response.data.success.sponserData["sponsor_uuid"];
            if (!sponsor) {
              sponsorListDummy["selectedItem"] = selectedUuid;
            }
          }
          if (response.data.success.allWinnerData) {
            winnerData = response.data.success.allWinnerData;
            if (winnerData[0]?.winners) {
              winnerList = winnerData[0]?.winners;
            }
          }
          if (response.data.success.allLcdData) {
            dealAllLcdListData = response.data.success.allLcdData;
            if (!deal && dealAllLcdListData.length) {
              deal = dealAllLcdListData[0]?.deal_uuid;
            }
          }
          if (response.data.success.allDealData) {
            allDealData = response.data.success.allDealData;
            if (deal) {
              const checkFlag = allDealData.findIndex(
                (item) => item.uuid === deal
              );
              if (checkFlag !== -1) {
                dealListDummy["selectedMaindeal"] =
                  allDealData[checkFlag].main_deal_uuid;
                dealListDummy["selectedItem"] = deal;
              } else if (allDealData.length) {
                dealListDummy["selectedMaindeal"] =
                  allDealData[0].main_deal_uuid;
                dealListDummy["selectedItem"] = allDealData[0].uuid;
              }
            }
            dealListDummy["list"] =
              response.data.success.dropdownDealList || [];
          }
          let finalSelectedList = {
            ...tempSelectedValue,
            main_deal_uuid: dealListDummy?.selectedMaindeal || "",
            deal_uuid: dealListDummy?.selectedItem || "",
            sponsor_uuid: sponsorListDummy?.selectedItem,
          };
          setTempSelectedValue({ ...finalSelectedList });
          setSponsorList({ ...sponsorListDummy });
          setDealList({ ...dealListDummy });
          setLcdWinnerList(winnerList);
          setDealData(allDealData);
          setDealAllLcdList(dealAllLcdListData);
          localStorage.setItem(
            "selectedOptions",
            JSON.stringify(EncryptData({ ...finalSelectedList }))
          );
          setToggleFlag(!toggleFlag);
        }
        loaderDisplayHideRedux({ isFullScreenLoaderDisplay: false });
      })
      .catch(function (error) {
        // handle error
        loaderDisplayHideRedux({ isFullScreenLoaderDisplay: false });
        console.log(error);
      });
  };

  const getStoreData = () => {
    let getSelectedData: any = getSelectedOptions();
    fetchStoreData(
      getSelectedData?.sponsor_uuid || "",
      getSelectedData?.deal_uuid || ""
    );
  };
  const onSaveSelectOption = () => {
    if (tempSelectedValue?.sponsor_uuid && tempSelectedValue?.deal_uuid) {
      const newActiveDealData = dealData.find(
        (dataItem) => dataItem?.uuid === tempSelectedValue?.deal_uuid
      );
      localStorage.setItem(
        "selectedOptions",
        JSON.stringify(
          EncryptData({
            main_deal_uuid: tempSelectedValue?.main_deal_uuid,
            deal_uuid: tempSelectedValue?.deal_uuid,
            sponsor_uuid: sponsorAccess
              ? userId
              : tempSelectedValue?.sponsor_uuid,
          })
        )
      );
      if (sponsorAccess) {
        if (tempSelectedValue?.main_deal_uuid !== dealList.selectedMaindeal) {
          getSponsorData();
        }
      } else {
        if (
          tempSelectedValue?.sponsor_uuid !== sponsorList.selectedItem ||
          tempSelectedValue?.deal_uuid !== dealList.selectedItem
        ) {
          getStoreData();
        }
      }
      setDealList({
        ...dealList,
        selectedItem: tempSelectedValue?.deal_uuid,
        selectedMaindeal: newActiveDealData?.main_deal_uuid,
      });
      setSponsorList({
        ...sponsorList,
        selectedItem: tempSelectedValue?.sponsor_uuid,
      });
    }
    setOpenDialog(false);
  };
  function filterDealData() {
    let array: any[] = [];
    dealList?.list?.forEach((option: any, index) => {
      if (
        tempSelectedValue?.sponsor_uuid &&
        option?.sponser_uuid === tempSelectedValue?.sponsor_uuid
      ) {
        array.push(
          <MenuItem
            key={option.match_title + "-" + index}
            value={option.deal_uuid + "/" + option.main_deal_uuid}
          >
            {option.match_title}
          </MenuItem>
        );
      }
    });
    return array;
  }
  const loaderDisplayHideRedux = useCallback(
    (data) => {
      dispatch(loaderDisplayHideAction(data));
    },
    // eslint-disable-next-line
    [dispatch]
  );

  const changeWinnerData = (data) => {
    if (data.alphacode_uuid) {
      const winnerList = lcdWinnerList.map((winnerData) => {
        if (data.alphacode_uuid === winnerData.alphacode_uuid) {
          return { ...winnerData, is_redeemed: 1, redeemed_by: userData.name };
        } else {
          return winnerData;
        }
      });
      setLcdWinnerList(winnerList);
    }
  };

  const toggleSideMenu = () => {
    setDisplayFullRightMenu(!displayFullRigthMenu);
    setDisplayFullSideMenu(!displayFullSideMenu);
  };

  return (
    <div className="theme-bg-white">
      {redirectToNotFoundPage ? <Redirect to="/login" /> : null}
      {displayIntoVideoItem ? (
        <VideoWrapper
          identifier={displayIntoVideoItem}
          isSkipInfoDisplay={true}
          autoplay={true}
          hideFn={() => setDisplayIntoVideoItem("")}
        />
      ) : userData ? (
        <section className="ml-0 pl-0">
          <div className="user-profile-wraper">
            {/* <div className='left-side-profile'> */}
            <Tab.Container
              id="left-tabs-example"
              defaultActiveKey={
                storeAccess ? "four" : sponsorAccess ? "four" : "three"
              }
            >
              <Row>
                <Col
                  className="left-side-profile"
                  sm={!displayFullSideMenu ? 2 : 3}
                >
                  <div
                    className={`left-side-wrapper ${
                      !displayFullSideMenu
                        ? isMobileOnly
                          ? "left-side-up-down"
                          : "left-side-left-right"
                        : ""
                    }`}
                  >
                    <div className="sidepanel-top">
                      <FaUserSecret />
                      {displayFullSideMenu ? (
                        isMobileOnly ? (
                          <FaAngleDoubleUp
                            onClick={() => toggleSideMenu()}
                            className="icon-right open-close-icon pointer"
                          />
                        ) : (
                          <FaAngleDoubleLeft
                            onClick={() => toggleSideMenu()}
                            className="icon-right open-close-icon pointer"
                          />
                        )
                      ) : isMobileOnly ? (
                        <FaAngleDoubleDown
                          onClick={() => toggleSideMenu()}
                          className="icon-right open-close-icon pointer"
                        />
                      ) : (
                        <FaAngleDoubleRight
                          onClick={() => toggleSideMenu()}
                          className="icon-right open-close-icon pointer"
                        />
                      )}
                    </div>
                    <Nav
                      variant="pills"
                      className="flex-column nav-items-wrapper"
                    >
                      <Nav.Item>
                        <Nav.Link eventKey="one">
                          <span className="nav-item-link">
                            {SIDE_MENU_PROFILE[selectedLanguage]?.my_profile}
                          </span>
                          <FaUser className="icon-right" />
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="two">
                          <span className="nav-item-link">
                            {
                              SIDE_MENU_PROFILE[selectedLanguage]
                                ?.change_password
                            }
                          </span>
                          <FaUserLock className=" icon-right" />
                        </Nav.Link>
                      </Nav.Item>
                      {normalOrAdminAccess ? (
                        <Nav.Item>
                          <Nav.Link eventKey="three">
                            <span className="nav-item-link">
                              {SIDE_MENU_PROFILE[selectedLanguage]?.my_cards}
                            </span>
                            <FaMoneyCheck className="icon-right" />
                          </Nav.Link>
                        </Nav.Item>
                      ) : null}
                      {sponserOrAdminAccess || storeAccess ? (
                        <Nav.Item>
                          <Nav.Link eventKey="four">
                            <span className="nav-item-link">
                              {SIDE_MENU_PROFILE[selectedLanguage]?.deal_list}
                            </span>
                            <FaSearchLocation className="icon-right" />
                          </Nav.Link>
                        </Nav.Item>
                      ) : null}
                      {storeAccess ? (
                        <Nav.Item>
                          <Nav.Link eventKey="nine">
                            <span className="nav-item-link">
                              {SIDE_MENU_PROFILE[selectedLanguage]?.card_list}
                            </span>
                            <FaSearchLocation className="icon-right" />
                          </Nav.Link>
                        </Nav.Item>
                      ) : null}
                      {sponserOrAdminAccess || storeAccess ? (
                        <Nav.Item>
                          <Nav.Link eventKey="five">
                            <span className="nav-item-link">
                              {
                                SIDE_MENU_PROFILE[selectedLanguage]
                                  ?.deal_winner_history
                              }
                            </span>
                            <FaHistory className="icon-right" />
                          </Nav.Link>
                        </Nav.Item>
                      ) : null}
                      {sponserOrAdminAccess ? (
                        <Nav.Item>
                          <Nav.Link eventKey="six">
                            <span className="nav-item-link">
                              {SIDE_MENU_PROFILE[selectedLanguage]?.award_list}
                            </span>
                            <FaSearchLocation className="icon-right" />
                          </Nav.Link>
                        </Nav.Item>
                      ) : null}
                      {normalOrAdminAccess ? (
                        <Nav.Item>
                          <Nav.Link eventKey="seven">
                            <span className="nav-item-link">
                              {
                                SIDE_MENU_PROFILE[selectedLanguage]
                                  ?.winner_history
                              }
                            </span>
                            <FaHistory className="icon-right" />
                          </Nav.Link>
                        </Nav.Item>
                      ) : null}
                      {sponserOrAdminAccess ? (
                        <Nav.Item>
                          <Nav.Link eventKey="eight">
                            <span className="nav-item-link">
                              {
                                SIDE_MENU_PROFILE[selectedLanguage]
                                  ?.store_address
                              }
                            </span>
                            <FaSearchLocation className="icon-right" />
                          </Nav.Link>
                        </Nav.Item>
                      ) : null}
                    </Nav>
                  </div>
                </Col>
                <Col
                  className={`right-side-profile ${
                    !displayFullRigthMenu ? "right-side-transition" : ""
                  }`}
                  id="right-side-element"
                  sm={!displayFullRigthMenu ? 10 : 9}
                >
                  <Tab.Content>
                    <Dialog
                      open={openDialog}
                      onClose={() => {
                        setOpenDialog(false);
                      }}
                      fullWidth
                      maxWidth="sm"
                    >
                      <DialogTitle className="d-flex align-self-center justify-content-center">
                        {SIDE_MENU_PROFILE[selectedLanguage]?.dialog_title}
                      </DialogTitle>
                      <DialogContent key={toggleFlag ? "true" : "false"}>
                        <Row className="py-2 mx-5">
                          <Col sm={12} className="">
                            <Row>
                              {sponsorAccess || userAcess ? (
                                <></>
                              ) : (
                                <TextField
                                  style={{ marginTop: 20 }}
                                  label={
                                    SIDE_MENU_PROFILE[selectedLanguage]
                                      ?.dialog_sponsor
                                  }
                                  select
                                  fullWidth
                                  variant="outlined"
                                  value={tempSelectedValue?.sponsor_uuid}
                                  id="pac-sponsor"
                                  margin="dense"
                                  // onChange={(e) => setSelectedStoreFromList(e.target.value)}
                                  onChange={(e) => {
                                    // setSponsorList({
                                    //   ...sponsorList,
                                    //   "selectedItem": e.target.value
                                    // })
                                    setTempSelectedValue({
                                      ...tempSelectedValue,
                                      sponsor_uuid: e.target.value,
                                    });
                                  }}
                                >
                                  <MenuItem value="" selected={true}>
                                    Please select sponsor
                                  </MenuItem>
                                  {sponsorList?.list?.map(
                                    (option: any, index) => (
                                      <MenuItem
                                        key={option.brand_name + "-" + index}
                                        selected={
                                          sponsorList?.selectedItem ===
                                          option.sponsor_uuid
                                        }
                                        value={option.sponsor_uuid}
                                      >
                                        {option.brand_name}
                                      </MenuItem>
                                    )
                                  )}
                                </TextField>
                              )}
                              <Fragment
                                key={
                                  tempSelectedValue?.sponsor_uuid ===
                                  sponsorList?.selectedItem
                                    ? "0"
                                    : "1"
                                }
                              >
                                {sponsorList?.selectedItem ||
                                tempSelectedValue?.sponsor_uuid ? (
                                  <TextField
                                    style={{ marginTop: 20 }}
                                    label={
                                      SIDE_MENU_PROFILE[selectedLanguage]
                                        ?.dialog_deal
                                    }
                                    select
                                    fullWidth
                                    variant="outlined"
                                    value={
                                      tempSelectedValue?.deal_uuid +
                                      "/" +
                                      tempSelectedValue?.main_deal_uuid
                                    }
                                    id="pac-deal"
                                    margin="dense"
                                    // onChange={(e) => setSelectedStoreFromList(e.target.value)}
                                    onChange={(e) => {
                                      setTempSelectedValue({
                                        ...tempSelectedValue,
                                        deal_uuid: e.target.value.split("/")[0],
                                        main_deal_uuid:
                                          e.target.value.split("/")[1],
                                      });
                                      // setDealList({
                                      //   ...dealList,
                                      //   "selectedItem": e.target.value
                                      // })
                                    }}
                                  >
                                    <MenuItem
                                      value=""
                                      selected={
                                        dealList?.selectedItem === ""
                                          ? true
                                          : false
                                      }
                                    >
                                      {
                                        SIDE_MENU_PROFILE[selectedLanguage]
                                          ?.dialog_message
                                      }
                                    </MenuItem>
                                    {sponsorAccess
                                      ? dealList?.list?.map(
                                          (data: any, index) => {
                                            return data?.deal_list.map(
                                              (listData: any) => (
                                                <MenuItem
                                                  key={
                                                    data.match_title +
                                                    "-" +
                                                    index
                                                  }
                                                  value={
                                                    listData.deal_uuid +
                                                    "/" +
                                                    data.main_deal_uuid
                                                  }
                                                >
                                                  {data.match_title +
                                                    "-" +
                                                    listData?.tp_name}
                                                </MenuItem>
                                              )
                                            );
                                          }
                                        )
                                      : filterDealData()}
                                  </TextField>
                                ) : null}
                              </Fragment>
                            </Row>
                          </Col>
                        </Row>
                      </DialogContent>
                      <DialogActions>
                        <Row className="mx-5 mb-2 w-100 d-flex align-self-center justify-content-center">
                          <Button
                            onClick={onSaveSelectOption}
                            variant="dark"
                            className="py-1 rounded-sm"
                            autoFocus
                          >
                            {SIDE_MENU_PROFILE[selectedLanguage]?.save}
                          </Button>
                          <Button
                            onClick={() => {
                              setOpenDialog(false);
                            }}
                            variant="primary"
                            className="ml-2 py-1 rounded-sm"
                            autoFocus
                          >
                            {SIDE_MENU_PROFILE[selectedLanguage]?.close}
                          </Button>
                        </Row>
                      </DialogActions>
                    </Dialog>
                    <Tab.Pane eventKey="one">
                      <UpdateProfile {...userData} />
                    </Tab.Pane>
                    <Tab.Pane eventKey="two">
                      <ChangePassword {...userData} />
                    </Tab.Pane>
                    {normalOrAdminAccess ? (
                      <Tab.Pane eventKey="three">
                        <LcdList displayFull={!displayFullSideMenu} />
                      </Tab.Pane>
                    ) : null}
                    {sponserOrAdminAccess || storeAccess ? (
                      <Tab.Pane eventKey="four">
                        {storeAccess ? (
                          <DealListStore
                            selectedSponsor={selectedBrand}
                            details={dealData}
                            openSelectOption={(open) => setOpenDialog(open)}
                          />
                        ) : (
                          <DealList
                            dealDetail={dealData}
                            selectedDeal={dealList?.selectedItem}
                            refreshData={getSponsorData}
                            openSelectOption={(open) => setOpenDialog(open)}
                          />
                        )}
                      </Tab.Pane>
                    ) : null}
                    {sponserOrAdminAccess || storeAccess ? (
                      <Tab.Pane eventKey="five">
                        {storeAccess ? (
                          <CertificateListStore
                            selectedSponsor={selectedBrand}
                            selectedDeal={dealList?.selectedItem}
                            dealDetail={dealData}
                            winnerList={lcdWinnerList}
                            openSelectOption={(open) => setOpenDialog(open)}
                            changeWinnerData={(data) => changeWinnerData(data)}
                          />
                        ) : (
                          <CertificateList
                            selectedDeal={dealList?.selectedItem}
                            dealDetail={dealData}
                            refreshData={getSponsorData}
                            winnerList={lcdWinnerList}
                            openSelectOption={(open) => setOpenDialog(open)}
                          />
                        )}
                      </Tab.Pane>
                    ) : null}
                    {sponserOrAdminAccess ? (
                      <Tab.Pane eventKey="six">
                        <AwardList
                          selectedDeal={dealList?.selectedItem}
                          dealDetail={dealData}
                          onSaveAwardDetail={onSaveAwardDetail}
                          openSelectOption={(open) => setOpenDialog(open)}
                        />
                      </Tab.Pane>
                    ) : null}
                    {normalOrAdminAccess ? (
                      <Tab.Pane eventKey="seven">
                        <WinnerHistory
                          selectedSponsor={selectedBrand}
                          selectedDeal={dealList?.selectedItem}
                          dealDetail={dealData}
                          winnerList={lcdWinnerList}
                          openSelectOption={(open) => setOpenDialog(open)}
                        />
                      </Tab.Pane>
                    ) : null}
                    {sponserOrAdminAccess ? (
                      <Tab.Pane eventKey="eight">
                        {/* <AddressList storeList={storeData} updateStoreAddress={updateStoreAddress}/> */}
                        <AddressList
                          storeList={storeData}
                          storeUsersList={storeUsersList}
                        />
                      </Tab.Pane>
                    ) : null}
                    {storeAccess ? (
                      <Tab.Pane eventKey="nine">
                        <DealLcdList
                          selectedSponsor={selectedBrand}
                          selectedDeal={dealList?.selectedItem}
                          dealDetail={dealData}
                          lcdList={dealAllLcdList}
                          openSelectOption={(open) => setOpenDialog(open)}
                        />
                      </Tab.Pane>
                    ) : null}
                  </Tab.Content>
                </Col>
              </Row>
            </Tab.Container>
          </div>
        </section>
      ) : null}
    </div>
  );
}
